import isbot from 'isbot'
import axios from 'axios'
import getConfig from 'next/config'
import getCookiesFromContext from '@src/utils/getCookiesFromContext'

const {
  publicRuntimeConfig: {
    optimizelyFeatureFlagId,
    optimizelyIgnoreCookieConsent,
  },
} = getConfig()

export const getOptimizelyDataFile = async (ctx: ExtendedNextPageContext) => {
  const cookies = getCookiesFromContext(ctx)
  const userAgentStr = ctx.req?.headers['user-agent'] || ''
  const isBot = isbot(userAgentStr)

  const oneTrustConsentCookie = cookies.get('OptanonConsent')

  // For internal .io domain testing we want to get around OneTrust configuration.
  // So if the cookie consent bypass is in a false/undefined state look for the cookie.
  // If it is set use it's value.
  const hasOneTrustConsent = !optimizelyIgnoreCookieConsent
    ? oneTrustConsentCookie?.includes('C0003:1')
    : optimizelyIgnoreCookieConsent

  if (!isBot && hasOneTrustConsent && optimizelyFeatureFlagId) {
    try {
      const dataFileRes = await axios.get(
        `https://cdn.optimizely.com/datafiles/${optimizelyFeatureFlagId}.json`
      )

      if (dataFileRes.status === 200) {
        return dataFileRes.data
      } else {
        console.warn(
          `Data File Did Not Respond OK. Got ${dataFileRes.status} instead.`
        )
        return null
      }
    } catch (err) {
      console.error('Problem encountered getting Optimizely Data File:')
      console.error(err)
      return null
    }
  }

  return null
}
